import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { deviceTargetsSearchSchema } from './-zod-schema';

export const Route = createFileRoute(
  '/_staff/it-operation-core/device-targets/',
)({
  validateSearch: zodValidator(deviceTargetsSearchSchema),
});
